import { useContext } from 'react';

import { HeaderDispatchContext, HeaderStateContext } from './HeaderProvider';

export const useHeaderDispatch = () =>
  useContext(HeaderDispatchContext);

export const useHeaderState = () =>
  useContext(HeaderStateContext);

export const useBlogIndexQueryString = () => {
  const state = useHeaderState();

  return state.blogIndexQueryString;
};

export const useIsShowingSystemAlert = () => {
  const state = useHeaderState();

  return state.isShowingSystemAlert;
};
